import { render, staticRenderFns } from "./AssignedSalesProducts.vue?vue&type=template&id=913d736c&"
import script from "./AssignedSalesProducts.vue?vue&type=script&lang=js&"
export * from "./AssignedSalesProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports